import { IRewardState, ITaskConfig, LotteryRewardTypes } from 'src/types';
import Calendar from 'assets/img/quest-list-14day.png';

export const get14DaysModalData = (
    translate: (key: string, params?: Record<string, string | number>, fallback?: string) => string,
    mission: ITaskConfig,
    daysLeft: number,
    goal: number
): IRewardState => ({
    id: '-1',
    lottery_reward_type: LotteryRewardTypes.LOGINS_SPECIAL,
    mission_id: mission.key,
    collection_id: -1,
    rolled: true,
    date: 1,
    renderParams: {
        name: translate('quest.14days.name', { count: daysLeft, goal: goal }),
        img: Calendar,
        congrats: '',
        background: 'linear-gradient(90deg, rgba(131, 102, 86, 0.12) 0%, rgba(204, 0, 255, 0.12) 100%)',
        desc: translate('quest.14days.desc', { goal: goal }),
        modalBackground: '#003C96',
        modalTitle: translate('quest.14days.modal.title', { goal: goal }),
        modalImg: 'https://st.okcdn.ru/static/ny2025-assets/0-0-1/quest-lenta.png',
        modalDescription: translate('quest.14days.desc', { goal: goal })
    }
});
